import React from 'react';
import Plot from 'react-plotly.js';
import { useFetchOption } from '../hooks/useFetchOption';
import { useGetFillValue } from '../hooks/useGetFillValue';

const SingleNumericChart = ({ geoserverUrl, mapLayerName, mapData, mapLegendData, mapOption }) => {
  
  const mapValueData = useFetchOption(geoserverUrl, mapLayerName, mapData.variable, mapOption);

  const mapChartProps = useGetFillValue(mapLegendData, mapData.variable, mapValueData )
  
  if ( mapValueData !== '' && mapChartProps !== '' ) {

  if ( mapValueData < 0) {        
    return (
      <div style={{ 
      borderBottom: '4px solid gray', 
      padding: '10px', 
      marginBottom: '10px', 
      width: '93%',
      borderBottomColor: 'gray', // Solo se aplica color al borde inferior
      borderBottomWidth: '2px', // Se establece el ancho del borde inferior
      boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.3)' // Añadida sombra
      }}>
      <div style={{ fontSize: '30px', textAlign: 'center', fontWeight: 'bold', marginBottom: '5px', }}>Sin información</div>
      </div>
  );
  }

  return (
    <div className="chart-container">
    <div style={{ 
      borderBottom: '4px solid blue', 
      width: '100%',
      borderBottomColor: 'blue', // Solo se aplica color al borde inferior
      borderBottomWidth: '2px', // Se establece el ancho del borde inferior
      boxShadow: '2px 2px 5px rgba(0, 0, 0, 0.3)' // Añadida sombra
      }}>
    <Plot
      data={[
        {
          x: [''],
          y: [mapValueData],
          type: 'bar',
          name: mapOption.slice(0,15),
          yaxis: 'y1',
          marker: { color: mapChartProps.fill },
          offsetgroup: 'A', // Grupo para las barras de Variable 1
          hovertemplate: `%{y:,.2f} ${mapData.unit}` 
        }
      ]}
      layout={{
        barmode: 'group',
        bargap: 0.2, // Espacio entre las barras
        yaxis: {
          title: mapLayerName, 
          side: 'left',
          range: [0, mapChartProps.maxLimit], 
          // tickformat: ',.2f' 
         },
        showlegend: false,
        autosize: true, // Ajuste automático del tamaño
        margin: {
          t: 10, // Ajuste de la altura del título
          b: 20 
        }
      }}
      config={{ displayModeBar: false }}
      style={{ width: '100%', height: '100%' }}
    />
    </div></div>
  );
}
};

export default SingleNumericChart;
